import { render, staticRenderFns } from "./VarejoInteligente.vue?vue&type=template&id=146455e9&"
import script from "./VarejoInteligente.vue?vue&type=script&lang=js&"
export * from "./VarejoInteligente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports